import React from 'react';

import { useFlowState } from '@betterment/js-runtime';
import { Box, IconButton, WorkflowHeader } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { FirmLogo } from '../FirmLogo';

const FlowHeader: React.FC<{ exitToPath: string; title: string }> = ({ exitToPath, title }) => {
  const { goToPreviousStep, getPreviousStep } = useFlowState();

  const hasPreviousStep = getPreviousStep() !== undefined;
  const navigate = useNavigate();

  return (
    <WorkflowHeader css={{ width: '100%' }}>
      <WorkflowHeader.Leading>
        <Box css={{ display: 'flex', gap: 'space.800', alignItems: 'center' }}>
          {hasPreviousStep && (
            <IconButton name="LeftArrow" label="Back" spacing="compact" onClick={() => goToPreviousStep()} />
          )}
          {!hasPreviousStep && <FirmLogo />}
        </Box>
      </WorkflowHeader.Leading>
      <WorkflowHeader.Title>{title}</WorkflowHeader.Title>
      <WorkflowHeader.Trailing>
        <IconButton name="X" label="Exit" spacing="compact" onClick={() => void navigate(exitToPath)} />
      </WorkflowHeader.Trailing>
    </WorkflowHeader>
  );
};

export default FlowHeader;
